(function() { window.GUID_a3b5093a_d67d_4b7f_90a2_8b285016d12d = { getGuid: function() { return "a3b5093a-d67d-4b7f-90a2-8b285016d12d"; } }; })();
var CompuSport;
(function (CompuSport) {
    function GetCookie(cookieName) {
        return $.cookie('CSCookie.' + cookieName);
    }
    CompuSport.GetCookie = GetCookie;
    function SetCookie(cookieName, value) {
        $.removeCookie('CSCookie.' + cookieName);
        $.cookie('CSCookie.' + cookieName, value, { expires: 365, path: '/' });
    }
    CompuSport.SetCookie = SetCookie;
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=Cookie.js.map
